import debate from './endpoints/debate.js';
import document from './endpoints/document.js';
import citations from './endpoints/citations';
import counterpoint from './endpoints/counterpoint';
import instructions from './endpoints/instructions.js';
import invitation from './endpoints/invitation';
import organization from './endpoints/organization';
import publicView from './endpoints/publicView';
import team from './endpoints/team.js';
import user from './endpoints/user.js';
import logger from './endpoints/logger.js';

export const xhr = {
  ...debate,
  ...document,
  ...citations,
  ...counterpoint,
  ...instructions,
  ...invitation,
  ...organization,
  ...publicView,
  ...team,
  ...user,
  ...logger,
};
